export default "__VITE_ASSET__DiuDScgR__"